import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import OneDonation from '../onedonation/OneDonation';
import PopupCart from '../component/PopupCart';
import { useTranslation } from 'react-i18next';
import SEO from '../component/SEO';

const Homepage = () => {
    const [products, setProducts] = useState([]);
    const { t, i18n } = useTranslation();

    useEffect(() => {
        axios
            .get(`${API_BASE_URL}/home/cos/`, {
                headers: {
                    'Accept-Language': i18n.language
                },
            })
            .then(response => {
                setProducts(response.data);
            })
            .catch(error => {
                console.error(t('common.errorFetchingCategories'), error);
            });

    }, [i18n.language]);

    return (
        <div className="test_block">
            <SEO />
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <h3 className="main-content__main-products desktop-title">{t('home.productsTitle')}</h3>
                        <div className="desktop-content">
                            <p>{t('home.productsDescription')}</p>
                        </div>
                    </div>
                </div>
                
                {/* CSS Grid гарантирует одинаковую высоту всех карточек в ряду */}
                <div className="products-cards-grid">
                    {Array.isArray(products) && products.length > 0 && products.map(product => (
                        <div key={product.id} className="main-content__product product-box">
                            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                                <div className="main-content__product__image" itemProp="image">
                                    <img src={product.image} alt={product.title} />
                                </div>
                                <p className="main-content__product__name" itemProp="name">{product.title}</p>
                                <p className="main-content__product__description">{product.detail}</p>
                            </div>
                            <div className="main-content__product__to-cart-box" itemProp="offers">
                                <span className="main-content__product__price">
                                    <span className="product-total-amount" itemProp="price">{product.count}</span> 
                                    <span> {t('home.currency')}</span>
                                </span>
                                
                                <PopupCart title={product.title} count={product.count} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>      
            <OneDonation />

        </div>
    );
};

export default Homepage;
